import { useState } from "react";
import {
  Group,
  Box,
  Collapse,
  ThemeIcon,
  Text,
  UnstyledButton,
  rem,
  Flex,
} from "@mantine/core";
import { IconCalendarStats, IconChevronRight } from "@tabler/icons-react";
import classes from "../../_style/NavbarLinksGroup.module.css";
import { LinksGroupProps } from "../../model/_base/LinksGroupProps";
import { useLocation, useNavigate } from "react-router-dom";
import { MessageResponse } from "../../../model/MessageResponse";
import { noCheckAuth, repositorySign } from "../../_const/_constVar";

export function LinksGroup({
  icon: Icon,
  label,
  initiallyOpened,
  link,
  code,
  links,
}: LinksGroupProps) {
  const hasLinks = Array.isArray(links);
  const [opened, setOpened] = useState(initiallyOpened || false);
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const formatLink = (link: any) => {
    // Nếu link không chứa "/", thêm "/" vào đầu
    return link.startsWith("/") ? link : `/${link}`;
  };
  const userName = localStorage.getItem("userName");

  const items = (hasLinks ? links : []).map((link) => (
    <Text<"a">
      component="a"
      className={classes.link}
      href={link.link}
      key={link.label}
      onClick={async (event) => {
        event.preventDefault();
        const isHomePage =
          link.link === "/" ||
          link.link === "/dashboard" ||
          link.link === "/method/folders-task-old";
        if (isHomePage) navigate(link.link);
        else {
          // khong năm trong danh sach bo qua check quyen
          if (!noCheckAuth.includes(link.link)) {
            var resCheck = await repositorySign.get<
              MessageResponse<Array<string>>
            >("/api/v1/home/check");
            if (resCheck && resCheck?.data && resCheck.success) {
              if (resCheck.data && resCheck.data.length > 0) {
                if (
                  resCheck.data.findIndex((x) =>
                    link.code.toLowerCase().includes(x.toLowerCase())
                  ) >= 0
                )
                  navigate(link.link);
                else navigate("/dashboard");
              } else navigate("/dashboard");
            } else navigate("/dashboard");
          } else navigate(link.link);
        }
      }}
      //  data-active={activeLink === link.label || undefined}
      style={{
        color: formatLink(link.link) === pathname ? "#006bb8" : "black",
        backgroundColor:
          formatLink(link.link) === pathname
            ? "rgba(0,119,204,0.2)"
            : "initial",
      }}
    >
      {link.label}
    </Text>
  ));

  return (
    <>
      <UnstyledButton
        onClick={async () => {
          setOpened((o) => !o);
          if (noCheckAuth.includes(link ?? "")) {
            navigate(link ?? "/dashboard");
          } else if (!hasLinks) {
            var resCheck = await repositorySign.get<
              MessageResponse<Array<string>>
            >("/api/v1/home/check");
            if (resCheck && resCheck?.data && resCheck.success) {
              if (resCheck.data && resCheck.data.length > 0) {
                if (
                  resCheck.data.findIndex((x) =>
                    code.toLowerCase().includes(x.toLowerCase())
                  ) >= 0
                )
                  navigate(link ?? "/dashboard");
                else navigate("/dashboard");
              } else navigate("/dashboard");
            } else navigate("/dashboard");
          }
        }}
        className={classes.control}
      >
        <Group justify="space-between" gap={0}>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              fontWeight: "bold",
            }}
            onClick={async () => {}}
          >
            <ThemeIcon variant="transparent" size={25}>
              <Icon style={{ width: rem(25), height: rem(25) }} />
            </ThemeIcon>
            <Box ml="md">{label}</Box>
          </Box>
          {hasLinks && (
            <IconChevronRight
              className={classes.chevron}
              stroke={1.5}
              style={{
                width: rem(25),
                height: rem(25),
                transform: opened ? "rotate(-90deg)" : "none",
              }}
            />
          )}
        </Group>
      </UnstyledButton>
      {hasLinks ? <Collapse in={opened}>{items}</Collapse> : null}
    </>
  );
}

// const mockdata = {
//   label: 'Releases',
//   icon: IconCalendarStats,
//   links: [
//     { label: 'Upcoming releases', link: '/' },
//     { label: 'Previous releases', link: '/' },
//     { label: 'Releases schedule', link: '/' },
//   ],
// };

// export function NavbarLinksGroup() {
//   return (
//     <Box mih={220} p="md">
//       <LinksGroup {...mockdata} />
//     </Box>
//   );
// }
